
import React, { Component, createRef } from "react";
import { Document, Page, pdfjs }       from "react-pdf";
import styles                          from "./pdf_viewer_portrait.module.css";

/* ------------------------------------------------------------------
   Tell react‑pdf where the worker script lives.
   Using the CDN keeps the bundle small and always matches the version
   shipped with react‑pdf / pdfjs‑dist.
   ------------------------------------------------------------------ */
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.mjs`;

const isPortrait = () => window.matchMedia("(orientation: portrait)").matches;


class PDFViewer extends Component 
{
  constructor(props) 
  {
    super(props);

    this.state = {
      numPages: null,          // total pages in the PDF
      currentPage: 1,
      pageWidth: null,         // width of an unscaled first page
      containerWidth: null,    // current width of the scroll container
      outline: [],              // extracted table‑of‑contents
      showSidebar: false
    };

    /* refs --------------------------------------------------------- */
    this.containerRef = createRef(); // the scrolling area
    this.pageRefs     = {};          // one ref per page

    /* bindings ----------------------------------------------------- */
    this.handleResize           = this.handleResize.bind(this);
    this.onDocumentLoadSuccess  = this.onDocumentLoadSuccess.bind(this);
    this.onFirstPageLoad        = this.onFirstPageLoad.bind(this);
  }

  /* --------------------------------------------------------------- */
  /* LIFECYCLE                                                      */
  /* --------------------------------------------------------------- */
  componentDidMount() 
  {
    this.handleResize();                 // set initial width
  }

  componentWillUnmount() 
  {
    window.removeEventListener("resize", this.handleResize);
  }


  /* --------------------------------------------------------------- */
  /* EVENT HANDLERS                                                  */
  /* --------------------------------------------------------------- */
  handleResize() 
  {
    if (this.containerRef.current) 
    {
      this.setState({ containerWidth: this.containerRef.current.offsetWidth });
    }
  }

  async onDocumentLoadSuccess(pdf) 
  {
    /* total pages + outline --------------------------------------- */
    const outline = await pdf.getOutline();
    this.pdfDoc   = pdf;                 // keep a handle for outline clicks
    this.setState({
      numPages: pdf.numPages,
      outline
    });
  }

  onFirstPageLoad(page) 
  {
    /* page.originalWidth is the natural width of page 1 at scale 1 */
    if (!this.state.pageWidth) 
    {
      this.setState({ pageWidth: page.originalWidth });
    }
  }
    

  //----------------------------------------------------------------
  //  Download tghe current white paper
  //----------------------------------------------------------------
  downloadPDF = async () => 
  {
    const { file } = this.props;      // string URL, import URL, File, or Blob

    /* If `file` is already a plain same‑origin URL you *can* skip fetch()
      and just set link.href = file; but the fetch → blob path is the most
      bullet‑proof (Safari, auth headers, etc.).                        */
    let blob;

    if (file instanceof Blob) 
    {
      blob = file;                   // you got a File/Blob from the parent
    } else 
    {
      const resp = await fetch(file);
      blob = await resp.blob();
    }

    const url       = URL.createObjectURL(blob);
    const link      = document.createElement("a");
    link.href       = url;
    link.download   = (typeof file === "string")   // get a nice filename
                      ? file.split("/").pop()
                      : file.name || "download.pdf";
    link.style.display = "none";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    //URL.revokeObjectURL(url);         // tidy up
  };


  /* --------------------------------------------------------------- */
  /* RENDER HELPERS                                                  */
  /* --------------------------------------------------------------- */
  renderPages() {
    const { numPages, pageWidth, containerWidth } = this.state;

    if (!numPages) return null;
    const scale = 1
    const pages = [];

    for (let pageNum = 1; pageNum <= numPages; pageNum += 1) 
    {
      if (!this.pageRefs[pageNum]) this.pageRefs[pageNum] = createRef();

      pages.push(
        <div key={`page_${pageNum}`} ref={this.pageRefs[pageNum]}>
          <Page
            pageNumber={pageNum}
            scale={scale}
            onLoadSuccess={pageNum === 1 ? this.onFirstPageLoad : null}
            className={styles.page}
            renderTextLayer={false}
            renderAnnotationLayer={false}
          />
        </div>
      );
    }

    return pages;
  }

  /* --------------------------------------------------------------- */
  /* MAIN RENDER                                                     */
  /* --------------------------------------------------------------- */
render() {
    const { file } = this.props;
    const { outline, showSidebar } = this.state;

    return (
      <div
        className={`${styles.wrapper} ${
          !showSidebar ? styles.noSidebar : ""
        }`}
      >
        {/* ------------- TOOLBAR --------------------------------- */}
        <div className={styles.toolbar}>
          <button onClick={this.downloadPDF}>Download and open</button>
        </div>
       
        {/* ------------- PDF PAGES ------------------------------ */}
        <div className={styles.viewerContainer} ref={this.containerRef}>
          <Document
            file={file}
            onLoadSuccess={this.onDocumentLoadSuccess}
            loading={<div>Loading PDF…</div>}
            className={styles.document}
            renderMode="canvas"
          >
            {this.renderPages()}
          </Document>
        </div>
      </div>
    );
  }
}

/*
  render() 
  {
    const { file } = this.props; // string URL or File/Blob

    return (
      
      <div className={styles.wrapper}>

        {/* ----------- NAVIGATION AND DOWNLOAD---------------------- *//*}
        <div className={styles.toolbar}>
          <button onClick = {() => this.downloadPDF()}>Download</button>
        </div>

        {/* ---------- SCROLL CONTAINER --------------------------- *//*}
        <div className={styles.viewerContainer} ref={this.containerRef}>
          <Document
            file={file}
            onLoadSuccess={this.onDocumentLoadSuccess}
            loading={<div>Loading PDF…</div>}
            className={styles.document}
            renderMode="canvas"
          >
            {this.renderPages()}
          </Document>
        </div>
      </div>
    );
  }
*/

export default PDFViewer;















/*
import React, { Component, createRef } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import styles from "./pdf_viewer.module.css";

// Load worker

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/4.8.69/pdf.worker.mjs`;

export default class PDFViewer extends Component {
  constructor(props) 
  {
    super(props);
    this.state = {
      numPages: null,
      pageWidth: null,
      containerWidth: null,
      outline: [],
    };
    this.pageRefs     = {}; 
    this.containerRef = createRef();
    this.onResize     = this.onResize.bind(this);
  }

  componentDidMount() 
  {
    this.updateContainerWidth();
    window.addEventListener("resize", this.onResize);
  }

  componentWillUnmount() 
  {
    window.removeEventListener("resize", this.onResize);
  }

  onResize() 
  {
    this.updateContainerWidth();
  }

  updateContainerWidth() 
  {
    if (this.containerRef.current) 
    {
      this.setState({ containerWidth: this.containerRef.current.offsetWidth });
    }
  }

  onDocumentLoadSuccess = async (pdf) => 
  {
    this.setState({ numPages: pdf.numPages });
    this.pdfDoc = pdf;

    const outline = await pdf.getOutline();
    this.setState({ outline });
  };


  onPageLoadSuccess = (page) => {
    if (!this.state.pageWidth) {
      this.setState({ pageWidth: page.originalWidth });
    }
  };


  downloadPDF = () => 
  {
    const link          = document.createElement("a");
    link.href           = this.props;                   // relative to public/
    link.download       = "BSDC.pdf";                   // file name to save as
    link.style.display  = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

 */

 /*

 scrollToOutlineItem = async (item) => 
  {
    try 
    {
      const pdf = this.pdfDoc;

      if (!item.dest) 
      {
        alert("No page specified.");
        return;
      }

      const destination = await pdf.getDestination(item.dest);

      if (!destination || !destination[0]) 
      {
        alert("Destination not resolved.");
        return;
      }

      const ref = destination[0];

      // If ref is a name (string), resolve it
      let pageIndex;
      
      if (typeof ref === "object" && ref.num !== undefined) 
      {
        // Named reference
        pageIndex = await pdf.getPageIndex(ref);
      } 
      else if (typeof ref === "string") 
      {
        // Destination is named
        const namedDest = await pdf.getDestination(ref);
        if (namedDest && namedDest[0]?.num !== undefined) 
        {
          pageIndex = await pdf.getPageIndex(namedDest[0]);
        }
      }

      if (pageIndex !== undefined) 
      {
        const pageNum = pageIndex + 1;
        this.setState({ currentPage: pageNum });
      } 
      else 
      {
        alert("Unable to resolve page.");
      }
    } 
    catch (err) 
    {
      console.warn("Error scrolling to outline item:", err);
      alert("Error trying to locate the section.");
    }
  };


  renderOutline(outline) {
    if (!outline || outline.length === 0) return <p>No outline found.</p>;

    return (
      <ul className={styles.navList}>
        {outline.map((item, idx) => (
          <li
            key={idx}
            onClick={() => this.scrollToOutlineItem(item)}
            className={styles.navItem}
          >
            {item.title}
          </li>
        ))}
      </ul>
    );
  }

  renderPages() 
  {
    //const { file } = this.props;
    const { numPages, pageWidth, containerWidth } = this.state;

    if (!numPages) return null;

    const scale = pageWidth && containerWidth
      ? ((containerWidth - 32) / pageWidth) * 0.95
      : 1;

    const pages = [];

    for (let i = 1; i <= numPages; i++) 
    {
      const i = this.state.currentPage;
      this.pageRefs[i] = React.createRef();
      
      pages.push(
        <div key={`page_${i}`} ref={this.pageRefs[i]}>
          <Page
            pageNumber={i}
            scale={scale}
                onLoadSuccess={i === 1 ? this.onPageLoadSuccess : null}
                className={styles.page}
                renderMode="canvas"
                renderTextLayer={false}
                renderAnnotationLayer={false}
          />
        </div>
      );
    }
    return pages;
  }

  render() 
  {
    const { file } = this.props;
    const { outline } = this.state;

    //console.log('File:', file)  

    return (
      <div className={styles.wrapper}>
        <aside className={styles.sidebar}>
          <div className={styles.sidebarTitle}>📘 Contents</div>
          {this.renderOutline(outline)}
        </aside>

        <div className={styles.viewerContainer} ref={this.containerRef}>
          <Document
            file={file}
            onLoadSuccess={this.onDocumentLoadSuccess}
            className={styles.document}
            loading={<div>Loading PDF…</div>}
          >
            {this.renderPages()}
          </Document>
        </div>
      </div>
    );
  }
}
*/




